import { observable, action, computed } from 'mobx';
import { ReqInputMsg, Addition, callCmd } from 'lib/reqInputMsg';
import moment from 'moment';
import { notification } from 'antd';

export default class TransStore {
  constructor(root) {
    this.root = root;
  }

  //----------------------------------
  /* Mainstore에서 세션만료 처리하기위해 */
  @observable
  _commonStoreInfo = null;

  @computed
  get commonStoreInfo() {
    return this._commonStoreInfo;
  }

  @action
  setCommonStoreInfo = (storeInfo) => {
    this._commonStoreInfo = storeInfo;
  };

  //----------------------------------
  /* 검색조건 */
  @observable 
  _valCondition = {
    strDate: moment().subtract(1, 'month').format('YYYY-MM-DD'),
    endDate: moment().format('YYYY-MM-DD'),
    orStat: '',

    orUserId: '',
    orUserNm: '',
    ceCd: '',
    ceBranchCd: '',
    orCartNo: '',

    pageIdx: 1,
    recordCountPerPage: 10,
    pageIdxUser: 1,
  };

  @computed
  get valCondition() {
    return this._valCondition;
  }

  @action
  onChangValue = (dataNm, dataVal) => {
    this._valCondition = {
      ...this._valCondition,
      [dataNm]: dataVal
    };
  };
  //----------------------------------
  /* 상세데이터 */
  @observable
  _detailData = [];

  @computed
  get detailData() {
    return this._detailData;
  }

  @observable
  _pageInfoUser = null;

  @computed
  get pageInfoUser() {
    return this._pageInfoUser;
  }

  @action
  onDetailData = (data) => {
    this._detailData = data;
  };
  
  //----------------------------------
  @observable 
  _orderCnt = null;

  @computed
  get orderCnt() {
    return this._orderCnt;
  }

  @observable 
  _orderList = [];

  @computed
  get orderList() {
    return this._orderList;
  }

  @observable
  _pageInfo = null;

  @computed
  get pageInfo() {
    return this._pageInfo;
  }
  //----------------------------------
  @action
  onClear = () => {
    this._orderCnt = null;
    this._orderList = [];
    this._pageInfo = null;
    this._detailData = [];
    this._pageInfoUser = null;

    this._valCondition = {
      ...this._valCondition,
      strDate: moment().subtract(1, 'month').format('YYYY-MM-DD'),
      endDate: moment().format('YYYY-MM-DD'),
      orStat: '',

      orUserId: '',
      orUserNm: '',
      ceCd: '',
      ceBranchCd: '',
      orCartNo: '',

      pageIdx: 1,
      recordCountPerPage: 10,
      pageIdxUser: 1,
    };
  };
  //-----------------------------------
  //  주문이력 관련
  //-----------------------------------
  @action
  disOrderCnt = async () => {
    let addition = new Addition();
    addition.setCmdName('DIS-ORDER-CNT');

    var reqInputMsg = new ReqInputMsg();
    reqInputMsg.setAddition(addition);

    reqInputMsg.addParam({paraName: 'strDate', paraValue: this._valCondition.strDate});
    reqInputMsg.addParam({paraName: 'endDate', paraValue: this._valCondition.endDate});

    return await callCmd(reqInputMsg, 'order')
      .then((res) => {
        if (res.error.code === '0000') {
          // notification.success({placement: 'bottomLeft', message:`조회가 성공하였습니다.`, duration: 2});
          if (res.result.length > 0) {
            this._orderCnt = res.result[0];
          } else {
            this._orderCnt = null;
          }
          
        } else if (res.error.code === '0003') {
          if (this._commonStoreInfo !== null) {
            this._commonStoreInfo.onSessionOut();
          }
        } else {
          notification.error({placement: 'bottomLeft', message:`리스트를 불러오는데 실패하였습니다.`, duration: 2, description: `${res.error.code}`});
          this._orderCnt = null;
        }
      }).catch((error) => {
        notification.error({placement: 'bottomLeft', message:`조회가 실패하였습니다.`, duration: 2, description: `서버 연결을 확인하세요.`});
        this._orderCnt = null;
        console.log('error', error);
      });
  };

  @action
  disOrderList = async (pageIdx, recordCountPerPage) => {
    if (pageIdx !== undefined && pageIdx !== null && this._valCondition.pageIdx !== pageIdx) {
      this._valCondition.pageIdx = pageIdx;
    }
    if (recordCountPerPage !== undefined && recordCountPerPage !== null && this._valCondition.recordCountPerPage !== recordCountPerPage) {
      this._valCondition.recordCountPerPage = recordCountPerPage;
    }

    let addition = new Addition();

    addition.setCmdName('DIS-ORDER-LIST');
    addition.setPageYn('Y');
    addition.setPageIndex(this._valCondition.pageIdx);
    addition.setRecordCountPerPage(this._valCondition.recordCountPerPage);

    var reqInputMsg = new ReqInputMsg();
    reqInputMsg.setAddition(addition);

    reqInputMsg.addParam({paraName: 'strDate', paraValue: this._valCondition.strDate});
    reqInputMsg.addParam({paraName: 'endDate', paraValue: this._valCondition.endDate});
    reqInputMsg.addParam({paraName: 'orStat', paraValue: this._valCondition.orStat});

    reqInputMsg.addParam({paraName: 'ceCd', paraValue: this._valCondition.ceCd});
    reqInputMsg.addParam({paraName: 'ceBranchCd', paraValue: this._valCondition.ceBranchCd});

    return await callCmd(reqInputMsg, 'order')
      .then((res) => {
        if (res.error.code === '0000') {
          // notification.success({placement: 'bottomLeft', message:`조회가 성공하였습니다.`, duration: 2});
          this._orderList = res.result;
          this._pageInfo = res.addition;
        } else if (res.error.code === '0003') {
          if (this._commonStoreInfo !== null) {
            this._commonStoreInfo.onSessionOut();
          }
        } else {
          notification.error({placement: 'bottomLeft', message:`리스트를 불러오는데 실패하였습니다.`, duration: 2, description: `${res.error.code}`});
          this._orderList = [];
          this._pageInfo = null;
          this._orderCnt = null;
        }
      }).catch((error) => {
        notification.error({placement: 'bottomLeft', message:`조회가 실패하였습니다.`, duration: 2, description: `서버 연결을 확인하세요.`});
        this._orderList = [];
        this._pageInfo = null;
        this._orderCnt = null;
        console.log('error', error);
      });
  };

  @action
  disOrderDetail = async (data, pageIdxUser, recordCountPerPage) => {
    if (pageIdxUser !== undefined && pageIdxUser !== null && this._valCondition.pageIdxUser !== pageIdxUser) {
      this._valCondition.pageIdxUser = pageIdxUser;
    }
    if (recordCountPerPage !== undefined && recordCountPerPage !== null && this._valCondition.recordCountPerPage !== recordCountPerPage) {
      this._valCondition.recordCountPerPage = recordCountPerPage;
    }

    let addition = new Addition();
    addition.setCmdName('DIS-ORDER-DETAIL');
    addition.setPageYn('Y');
    addition.setPageIndex(this._valCondition.pageIdxUser);
    addition.setRecordCountPerPage(this._valCondition.recordCountPerPage);

    var reqInputMsg = new ReqInputMsg();
    reqInputMsg.setAddition(addition);
    reqInputMsg.addParam({paraName: 'strDate', paraValue: this._valCondition.strDate});
    reqInputMsg.addParam({paraName: 'endDate', paraValue: this._valCondition.endDate});
    reqInputMsg.addParam({paraName: 'orStat', paraValue: this._valCondition.orStat});
    if (data !== undefined && data !== null && data.orCartNo !== undefined && data.orCartNo !== null) {
      reqInputMsg.addParam({paraName: 'orCartNo', paraValue: data.orCartNo});
    }

    reqInputMsg.addParam({paraName: 'orUserId', paraValue: this._valCondition.orUserId});
    reqInputMsg.addParam({paraName: 'orUserNm', paraValue: this._valCondition.orUserNm});
    reqInputMsg.addParam({paraName: 'ceCd', paraValue: this._valCondition.ceCd});
    reqInputMsg.addParam({paraName: 'ceBranchCd', paraValue: this._valCondition.ceBranchCd});

    return await callCmd(reqInputMsg, 'order')
      .then((res) => {
        if (res.error.code === '0000') {
          this._detailData = res.result;
          this._pageInfoUser = res.addition;
        } else if (res.error.code === '0003') {
          if (this._commonStoreInfo !== null) {
            this._commonStoreInfo.onSessionOut();
          }
        } else {
          notification.error({placement: 'bottomLeft', message:`리스트를 불러오는데 실패하였습니다.`, duration: 2, description: `${res.error.code}`});
          this._detailData = [];
          this._pageInfoUser = null;
        }
      }).catch((error) => {
        notification.error({placement: 'bottomLeft', message:`조회가 실패하였습니다.`, duration: 2, description: `서버 연결을 확인하세요.`});
        this._detailData = [];
        this._pageInfoUser = null;
        console.log('error', error);
      });
  };

  @action
  modOrderInfo = async (data) => {
    let paramList = data;

    paramList.map(item=>{return (
      delete item.orAddr
    )});

    let addition = new Addition();
    addition.setCmdName('MOD-ORDER-INFO');

    var reqInputMsg = new ReqInputMsg();
    reqInputMsg.setAddition(addition);
    reqInputMsg.addParam({paraName: 'orderList', paraValue: paramList});
    
    return await callCmd(reqInputMsg, 'order')
      .then((res) => {
        if (res.error.code === '0000') {
          if (res.result[0].resultMsg) {
            notification.success({placement: 'bottomLeft', message:`수정이 성공하였습니다.`, duration: 2});
            this.disOrderCnt();
            this.disOrderList();
            this.disOrderDetail(data[0]);
          } else {
            notification.success({placement: 'bottomLeft', message:`수정이 실패하였습니다.`, duration: 2});
          }
        } else if (res.error.code === '0003') {
          if (this._commonStoreInfo !== null) {
            this._commonStoreInfo.onSessionOut();
          }
        } else {
          notification.success({placement: 'bottomLeft', message:`수정이 실패하였습니다.`, duration: 2, description: `${res.error.code}`});
        }
      }).catch((error) => {
        notification.error({placement: 'bottomLeft', message:`수정이 실패하였습니다.`, duration: 2, description: `서버 연결을 확인하세요.`});
        console.log('error', error);
      });
  };

  @action
  delOrderInfo = async (data) => {
    let addition = new Addition();
    addition.setCmdName('DEL-ORDER-INFO');

    var reqInputMsg = new ReqInputMsg();
    reqInputMsg.setAddition(addition);
    reqInputMsg.addParam({paraName: 'orNo', paraValue: data.orNo.toString()});

    return await callCmd(reqInputMsg, 'order')
      .then((res) => {
        if (res.error.code === '0000') {
          if (res.result[0].resultMsg) {
            notification.success({placement: 'bottomLeft', message:`삭제가 성공하였습니다.`, duration: 2});
            this.disOrderCnt();
            this.disOrderList();
            this.disOrderDetail(data);
          } else {
            notification.success({placement: 'bottomLeft', message:`삭제가 실패하였습니다.`, duration: 2});
          }
        } else if (res.error.code === '0003') {
          if (this._commonStoreInfo !== null) {
            this._commonStoreInfo.onSessionOut();
          }
        } else {
          notification.success({placement: 'bottomLeft', message:`삭제가 실패하였습니다.`, duration: 2, description: `${res.error.code}`});
        }
      }).catch((error) => {
        notification.error({placement: 'bottomLeft', message:`삭제가 실패하였습니다.`, duration: 2, description: `서버 연결을 확인하세요.`});
        console.log('error', error);
      });
  };

  //-----------------------------------
  //  택배사, 운송번호 엑셀 일괄 변경
  //-----------------------------------
  @observable
  _excelUploadIng = false;

  @computed
  get excelUploadIng() {
    return this._excelUploadIng;
  }
  
  @action
  onExcelUploadIng = (boolen) => {
    this._excelUploadIng = boolen;
  }
  
  @action
  modOrderTracker = async (uploadList) => {
    if (uploadList.length <= 0) {
      notification.error({placement: 'bottomLeft', message:`데이터가 없습니다. 파일을 확인하세요..`, duration: 2});
      return;
    }
    
    this._excelUploadIng = true;
    let paramList = [];
    uploadList.map(item=>{return (
      (item.orNo !== undefined && item.orNo !== null && item.orNo !== '') &&
      paramList.push({
        orNo: item.orNo,
        orTracker: item["택배사id"],
        orInvoiceNo: item["송장번호"],
        // orInvoiceNoEtc: item["송장번호(추가)"],
      })
    )});

    let addition = new Addition();
    addition.setCmdName('MOD-ORDER-TRACKER');

    var reqInputMsg = new ReqInputMsg();
    reqInputMsg.setAddition(addition);
    reqInputMsg.addParam({paraName: 'uploadList', paraValue: paramList});
    
    return await callCmd(reqInputMsg, 'order')
      .then((res) => {
        if (res.error.code === '0000') {
          if (res.result[0].resultMsg) {
            notification.success({placement: 'bottomLeft', message:`택배정보 등록이 성공하였습니다.`, duration: 2});
            this._excelUploadIng = false;
            this.disOrderCnt();
            this.disOrderList();
          } else {
            notification.success({placement: 'bottomLeft', message:`택배정보 등록이 실패하였습니다.`, duration: 2});
            this._excelUploadIng = false;
          }
        } else if (res.error.code === '0003') {
          this._excelUploadIng = false;
          if (this._commonStoreInfo !== null) {
            this._commonStoreInfo.onSessionOut();
          }
        } else {
          notification.success({placement: 'bottomLeft', message:`택배정보 등록이 실패하였습니다.`, duration: 2, description: `${res.error.code}`});
          this._excelUploadIng = false;
        }
      }).catch((error) => {
        notification.error({placement: 'bottomLeft', message:`등록이 실패하였습니다.`, duration: 2, description: `서버 연결을 확인하세요.`});
        this._excelUploadIng = false;
        console.log('error', error);
      });

  };

  //-----------------------------------
  //  택배사 관련
  //-----------------------------------
  @observable
  _carriersList = [];

  @computed
  get carriersList() {
    return this._carriersList;
  }

  @action
  disCarriersList = async () => {   
    let addition = new Addition();
    addition.setCmdName('DIS-CARRIERS-LIST');
    
    var reqInputMsg = new ReqInputMsg();
    reqInputMsg.setAddition(addition);

    return await callCmd(reqInputMsg, 'order')
      .then((res) => {
        if (res.error.code === '0000') {
          // notification.success({placement: 'bottomLeft', message:`조회가 성공하였습니다.`, duration: 2});
          this._carriersList = res.result;
        } else if (res.error.code === '0003') {
          if (this._commonStoreInfo !== null) {
            this._commonStoreInfo.onSessionOut();
          }
        } else {
          notification.error({placement: 'bottomLeft', message:`택배사 리스트를 불러오는데 실패하였습니다.`, duration: 2, description: `${res.error.code}`});
          this._carriersList = [];
        }
      }).catch((error) => {
        notification.error({placement: 'bottomLeft', message:`실패하였습니다.`, duration: 2, description: `서버 연결을 확인하세요.`});
        this._carriersList = [];
        console.log('error', error);
      });
  };

  @observable
  _deliveryInfo = null;

  @computed
  get deliveryInfo() {
    return this._deliveryInfo;
  }

  @observable
  _deliveryInfoLoding = false;

  @computed
  get deliveryInfoLoding() {
    return this._deliveryInfoLoding;
  }

  @action
  disDeliveryInfo = async (carrierId, trackId) => {
    this._deliveryInfoLoding = true;
    let addition = new Addition();
    addition.setCmdName('DIS-DELIVERY-INFO');
    
    var reqInputMsg = new ReqInputMsg();
    reqInputMsg.setAddition(addition);

    reqInputMsg.addParam({paraName: 'carrierId', paraValue: carrierId});
    reqInputMsg.addParam({paraName: 'trackId', paraValue: trackId});

    return await callCmd(reqInputMsg, 'order')
      .then((res) => {
        if (res.error.code === '0000') {
          // notification.success({placement: 'bottomLeft', message:`조회가 성공하였습니다.`, duration: 2});
          if (res.result.length > 0) {
            this._deliveryInfo = res.result[0];
          } else {
            this._deliveryInfo = null;
          }
        } else if (res.error.code === '0003') {
          if (this._commonStoreInfo !== null) {
            this._commonStoreInfo.onSessionOut();
          }
        } else {
          notification.success({placement: 'bottomLeft', message:`배송조회에 실패하였습니다.`, duration: 2, description: `${res.error.code}`});
          this._deliveryInfo = null;
        }
        this._deliveryInfoLoding = false;
      }).catch((error) => {
        notification.error({placement: 'bottomLeft', message:`실패하였습니다.`, duration: 2, description: `서버 연결을 확인하세요.`});
        this._deliveryInfo = null;
        this._deliveryInfoLoding = false;
        console.log('error', error);
      });
  };
  
  
  //-----------------------------------
  //  반품 신청
  //-----------------------------------
  @action
  reqReturnInfo = async (data) => {
    let addition = new Addition();
    addition.setCmdName('REQ-RETURN-INFO');

    var reqInputMsg = new ReqInputMsg();
    reqInputMsg.setAddition(addition);
    reqInputMsg.addParam({paraName: 'orNo', paraValue: data.orNo.toString()});
    reqInputMsg.addParam({paraName: 'returnReason', paraValue: data.returnReason});
    reqInputMsg.addParam({paraName: 'orCnt', paraValue: data.orCnt.toString()});
    reqInputMsg.addParam({paraName: 'orCartNo', paraValue: data.orCartNo.toString()});

    return await callCmd(reqInputMsg, 'orderReturn')
      .then((res) => {
        if (res.error.code === '0000') {
          if (res.result[0].resultMsg) {
            notification.success({placement: 'bottomLeft', message:`반품신청에 성공하였습니다.`, duration: 2});
            this.disOrderDetail();
          } else {
            notification.success({placement: 'bottomLeft', message:`반품신청에 실패하였습니다.`, duration: 2});
          }
        } else if (res.error.code === '0003') {
          if (this._commonStoreInfo !== null) {
            this._commonStoreInfo.onSessionOut();
          }
        } else {
          notification.success({placement: 'bottomLeft', message:`반품신청에 실패하였습니다.`, duration: 2, description: `${res.error.code}`});
        }
      }).catch((error) => {
        notification.error({placement: 'bottomLeft', message:`반품신청에 실패하였습니다.`, duration: 2, description: `서버 연결을 확인하세요.`});
        console.log('error', error);
      });
  };

  //-----------------------------------
  //  반품 재구매 상품리스트
  //-----------------------------------
  @observable 
  _reOrderList = [];

  @computed
  get reOrderList() {
    return this._reOrderList;
  }

  @action
  reOrderGoodsList = async (data) => {
    let addition = new Addition();
    addition.setCmdName('REORDER-GOODS-LIST');
    
    var reqInputMsg = new ReqInputMsg();
    reqInputMsg.setAddition(addition);
    reqInputMsg.addParam({paraName: 'orPGdCd', paraValue: data.orPGdCd});
    
    return await callCmd(reqInputMsg, 'orderReturn')
      .then((res) => {
        if (res.error.code === '0000') {
          // notification.success({placement: 'bottomLeft', message:`조회가 성공하였습니다.`, duration: 2});
          this._reOrderList = res.result;
        } else if (res.error.code === '0003') {
          if (this._commonStoreInfo !== null) {
            this._commonStoreInfo.onSessionOut();
          }
        } else {
          notification.error({placement: 'bottomLeft', message:`리스트를 불러오는데 실패하였습니다.`, duration: 2, description: `${res.error.code}`});
          this._reOrderList = [];
        }
      }).catch((error) => {
        notification.error({placement: 'bottomLeft', message:`조회가 실패하였습니다.`, duration: 2, description: `서버 연결을 확인하세요.`});
        this._reOrderList = [];
        console.log('error', error);
      });
  };

  //-----------------------------------
  //  반품 재구매
  //-----------------------------------
  @action
  reOrderReturnInfo = async (data) => {
    let addition = new Addition();
    addition.setCmdName('REORDER-RETURN-INFO');

    var reqInputMsg = new ReqInputMsg();
    reqInputMsg.setAddition(addition);
    reqInputMsg.addParam({paraName: 'pOrNo', paraValue: data.pOrNo.toString()});
    reqInputMsg.addParam({paraName: 'orGdCd', paraValue: data.orGdCd});
    reqInputMsg.addParam({paraName: 'orGdSize', paraValue: data.orGdSize});
    reqInputMsg.addParam({paraName: 'orGdPrice', paraValue: data.orGdPrice.toString()});
    reqInputMsg.addParam({paraName: 'orCnt', paraValue: data.orCnt.toString()});
    reqInputMsg.addParam({paraName: 'orEtc', paraValue: data.orEtc});
    
    return await callCmd(reqInputMsg, 'orderReturn')
      .then((res) => {
        if (res.error.code === '0000') {
          if (res.result[0].resultMsg) {
            notification.success({placement: 'bottomLeft', message:`재구매가 성공하였습니다.`, duration: 2});
            this.disOrderDetail();
          } else {
            notification.success({placement: 'bottomLeft', message:`재구매가 실패하였습니다.`, duration: 2});
          }
        } else if (res.error.code === '0003') {
          if (this._commonStoreInfo !== null) {
            this._commonStoreInfo.onSessionOut();
          }
        } else {
          notification.success({placement: 'bottomLeft', message:`재구매가 실패하였습니다.`, duration: 2, description: `${res.error.code}`});
        }
      }).catch((error) => {
        notification.error({placement: 'bottomLeft', message:`재구매가 실패하였습니다.`, duration: 2, description: `서버 연결을 확인하세요.`});
        console.log('error', error);
      });
  };

  // 거래내역 한꺼번에 밀어 넣기
  @action
  uploadOrderList = async (uploadList) => {
    if (uploadList.length <= 0) {
      notification.error({placement: 'bottomLeft', message:`데이터가 없습니다. 파일을 확인하세요..`, duration: 2});
      return;
    }
    //console.log("uploadList", uploadList);

    let addition = new Addition();
    addition.setCmdName('UPLOAD-ORDER-LIST');

    var reqInputMsg = new ReqInputMsg();
    reqInputMsg.setAddition(addition);
    reqInputMsg.addParam({paraName: 'orderList', paraValue: uploadList});
    
    return await callCmd(reqInputMsg, 'order')
      .then((res) => {
        if (res.error.code === '0000') {
          if (res.result[0].resultMsg) {
            notification.success({placement: 'bottomLeft', message:`주문내역 업데이트가 성공하였습니다.`, duration: 2});
            console.log('주문내역 업데이트가 성공 ');
          } else {
            notification.success({placement: 'bottomLeft', message:`주문내역 업데이트가 실패하였습니다.`, duration: 2});
          }
        } else if (res.error.code === '0003') {
          if (this._commonStoreInfo !== null) {
            this._commonStoreInfo.onSessionOut();
          }
        } else {
          notification.success({placement: 'bottomLeft', message:`주문내역 업데이트가 실패하였습니다.`, duration: 2, description: `${res.error.code}`});
        }
      }).catch((error) => {
        notification.error({placement: 'bottomLeft', message:`주문내역 업데이트가 실패하였습니다.`, duration: 2, description: `서버 연결을 확인하세요.`});
        console.log('error', error);
      });
    }
}
  
